function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M9.083 14.457a4.87 4.87 0 1 1 0-9.74 4.87 4.87 0 0 1 0 9.74zm0-1.522a3.348 3.348 0 1 0 0-6.696 3.348 3.348 0 0 0 0 6.696zM29.627 14.457a4.87 4.87 0 1 1 0-9.74 4.87 4.87 0 0 1 0 9.74zm0-1.522a3.348 3.348 0 1 0 0-6.696 3.348 3.348 0 0 0 0 6.696z"
}), React.createElement("path", {
  d: "M3.605 9.587c-2.739 0-4.109 0-2.739-2.74C2.236 4.11 7.714 1.37 9.083 1.37c1.37 0 1.37 1.37 4.11 1.37 2.738 0 10.956 1.369 10.956 1.369s5.478 1.37 5.478 4.108c0 4.11-10.957 5.479-16.435 5.479 1.41-2.03 1.913-4.058.906-6.595-1.37-2.739-4.028-3.55-6.384-2.992C6.042 4.565 3.02 7.1 3.605 9.587zM17.12 2.029c2.739-1.37 7.029-.66 7.029-.66L26.888 0s.97 1.199.77 1.798l-.77 2.31-4.109-1.369s-1.631-.71-5.66-.71z"
}));

var SvgVehicleMotorcycleWithSidecar = function SvgVehicleMotorcycleWithSidecar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 15,
    viewBox: "0 0 35 15",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleMotorcycleWithSidecar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-motorcycle-with-sidecar.10865a20.svg";
export { ForwardRef as ReactComponent };